module.exports = {

    data() {
        return {
            map: null,
            mapZoom: 5,
        }
    },

    mounted() {
        App.bus.$on('google-maps-ready', this.createMap)
    },

    methods: {

        createMap(){
            this.map = new google.maps.Map(document.getElementById(this.getMapId()), {
                center: {lat: 35.4649802, lng: -119.4938025},
                zoom: this.mapZoom,
                disableDefaultUI: true
            });
        },

        getMapId() {
            return 'map';
        }
    }
}
